// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ServerGroupPerDatabaseQueryGraphQueryVariables = Types.Exact<{
  serverGroupId: Types.Scalars["ID"]["input"];
  datname: Types.Scalars["String"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type ServerGroupPerDatabaseQueryGraphQuery = {
  __typename?: "GraphqlQuery";
  getQueryOverviewStatsForDatabaseGroup?: {
    __typename?: "QueryOverviewStatsSeries";
    id: string;
    avgTime?: Array<Array<number | null> | null> | null;
    pct90th?: Array<Array<number | null> | null> | null;
    pct95th?: Array<Array<number | null> | null> | null;
    pct98th?: Array<Array<number | null> | null> | null;
    pct99th?: Array<Array<number | null> | null> | null;
    avgIotime?: Array<Array<number | null> | null> | null;
  } | null;
};

export const ServerGroupPerDatabaseQueryGraphDocument = gql`
  query ServerGroupPerDatabaseQueryGraph(
    $serverGroupId: ID!
    $datname: String!
    $startTs: Int!
    $endTs: Int!
  ) {
    getQueryOverviewStatsForDatabaseGroup(
      serverGroupId: $serverGroupId
      datname: $datname
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      avgTime
      pct90th
      pct95th
      pct98th
      pct99th
      avgIotime
    }
  }
`;

/**
 * __useServerGroupPerDatabaseQueryGraphQuery__
 *
 * To run a query within a React component, call `useServerGroupPerDatabaseQueryGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerGroupPerDatabaseQueryGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerGroupPerDatabaseQueryGraphQuery({
 *   variables: {
 *      serverGroupId: // value for 'serverGroupId'
 *      datname: // value for 'datname'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useServerGroupPerDatabaseQueryGraphQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServerGroupPerDatabaseQueryGraphQuery,
    ServerGroupPerDatabaseQueryGraphQueryVariables
  > &
    (
      | {
          variables: ServerGroupPerDatabaseQueryGraphQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServerGroupPerDatabaseQueryGraphQuery,
    ServerGroupPerDatabaseQueryGraphQueryVariables
  >(ServerGroupPerDatabaseQueryGraphDocument, options);
}
export function useServerGroupPerDatabaseQueryGraphLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerGroupPerDatabaseQueryGraphQuery,
    ServerGroupPerDatabaseQueryGraphQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServerGroupPerDatabaseQueryGraphQuery,
    ServerGroupPerDatabaseQueryGraphQueryVariables
  >(ServerGroupPerDatabaseQueryGraphDocument, options);
}
// @ts-ignore
export function useServerGroupPerDatabaseQueryGraphSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerGroupPerDatabaseQueryGraphQuery,
    ServerGroupPerDatabaseQueryGraphQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupPerDatabaseQueryGraphQuery,
  ServerGroupPerDatabaseQueryGraphQueryVariables
>;
export function useServerGroupPerDatabaseQueryGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupPerDatabaseQueryGraphQuery,
        ServerGroupPerDatabaseQueryGraphQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupPerDatabaseQueryGraphQuery | undefined,
  ServerGroupPerDatabaseQueryGraphQueryVariables
>;
export function useServerGroupPerDatabaseQueryGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupPerDatabaseQueryGraphQuery,
        ServerGroupPerDatabaseQueryGraphQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServerGroupPerDatabaseQueryGraphQuery,
    ServerGroupPerDatabaseQueryGraphQueryVariables
  >(ServerGroupPerDatabaseQueryGraphDocument, options);
}
export type ServerGroupPerDatabaseQueryGraphQueryHookResult = ReturnType<
  typeof useServerGroupPerDatabaseQueryGraphQuery
>;
export type ServerGroupPerDatabaseQueryGraphLazyQueryHookResult = ReturnType<
  typeof useServerGroupPerDatabaseQueryGraphLazyQuery
>;
export type ServerGroupPerDatabaseQueryGraphSuspenseQueryHookResult =
  ReturnType<typeof useServerGroupPerDatabaseQueryGraphSuspenseQuery>;
export type ServerGroupPerDatabaseQueryGraphQueryResult = Apollo.QueryResult<
  ServerGroupPerDatabaseQueryGraphQuery,
  ServerGroupPerDatabaseQueryGraphQueryVariables
>;
